module.exports = __webpack_public_path__ + "img/index_v1_bg.0024a1bd.png";